<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      eager
      scrollable
      max-width="700"
      content-class="rounded-dialog"
    >
      <v-form ref="AddStrategicPriority" lazy-validation>
        <v-card rounded="lg" elevation="3">
          <!-- HEADER -->
          <v-card-title dark class="dialog-header">
            <div class="dialog-header-content">
              <div class="dialog-title-wrapper">
                <div class="dialog-icon">
                  <icon name="circle-add" />
                </div>

                <div class="dialog-text">
                  <div class="dialog-title">
                    {{ action }} Strategic Planning
                  </div>

                  <div class="dialog-subtitle">
                    Manage strategic goals, objectives, and performance
                    indicators.
                  </div>
                </div>
              </div>

              <v-btn icon class="close-btn" @click="closeD()">
                <icon name="circle-close" />
              </v-btn>
            </div>
          </v-card-title>

          <v-divider />

          <!-- BODY -->
          <v-card-text class="py-2">
            <v-container fluid>
              <v-row dense>
                <!-- STRATEGIC TYPE -->
                <!-- <v-col cols="12">
                  <div class="goal-description mb-4">
                    Strategic Planning Type
                  </div>

                  <v-row>
              
                    <v-col cols="12" md="6" class="field-spacing">
                      <div
                        class="metric-card"
                        :class="{ active: strat_type === 'SDP' }"
                        @click="strat_type = 'SDP'"
                      >
                        <div
                          class="custom-radio"
                          :class="{ active: strat_type === 'SDP' }"
                        >
                          <div class="custom-radio-dot"></div>
                        </div>

                        <div class="metric-content">
                          <div>
                            <div class="metric-title">SDP</div>
                            <div class="metric-subtitle">
                              Strategic Development Plan
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-col>

               
                    <v-col cols="12" md="6" class="field-spacing">
                      <div
                        class="metric-card"
                        :class="{ active: strat_type === 'SUC' }"
                        @click="strat_type = 'SUC'"
                      >
                        <div
                          class="custom-radio"
                          :class="{ active: strat_type === 'SUC' }"
                        >
                          <div class="custom-radio-dot"></div>
                        </div>

                        <div class="metric-content">
                          <div>
                            <div class="metric-title">SUC LEVELING</div>
                            <div class="metric-subtitle">
                              State Universities and Colleges Leveling
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-col> -->

                <!-- TITLE -->
                <v-col cols="12" class="mt-5">
                  <v-textarea
                    v-model="title"
                    label="Title"
                    outlined
                    auto-grow
                    rows="1"
                    :rules="[formRules.required]"
                    color="green"
                  />
                </v-col>

                <!-- YEAR FROM -->
                <v-col cols="12" md="6" class="mb-n1">
                  <v-autocomplete
                    v-model="dateFrom"
                    :items="yearListFrom"
                    item-text="description"
                    item-value="id"
                    label="Year From"
                    outlined
                    class="rounded-lg"
                    @change="onChangeDateFrom"
                  />
                </v-col>

                <!-- YEAR TO (SDP) -->
                <v-col cols="12" md="6" v-if="strat_type === 'SDP'">
                  <v-text-field
                    v-model="dateTo"
                    label="Year To"
                    outlined
                    class="rounded-lg"
                    readonly
                    :rules="[formRules.required]"
                    color="green"
                  />
                </v-col>

                <!-- YEAR TO (NON-SDP) -->
                <v-col cols="12" md="6" v-else>
                  <v-autocomplete
                    v-model="dateTo"
                    :items="yearListFrom"
                    item-text="description"
                    item-value="id"
                    label="Year To"
                    :readonly="action == 'Update'"
                    outlined
                    class="rounded-lg"
                    color="green"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-divider />

          <!-- ACTIONS -->

          <v-card-actions class="px-6 py-4">
            <v-spacer />

            <v-btn class="btn-cancel" outlined @click="closeD"> Cancel </v-btn>

            <v-btn class="btn-save" v-if="action === 'Add'" @click="addnew()">
              Add
            </v-btn>

            <v-btn
              class="btn-save"
              v-if="action === 'Update'"
              @click="update()"
            >
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- MESSAGE -->
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
      :timeout="3000"
    />
  </div>
</template>

<script>
import icon from "@/assets/icon.vue";
export default {
  components: {
    icon,
  },
  props: {
    data: null,
    action: null,
    tab: null,
  },

  data() {
    return {
      id: null,
      dialog: false,
      strat_type: "",
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      yearListFrom: [],
      period: null,
      assessed_by_user: null,
      final_rating_by_user: null,
      dateFrom: null,
      dateTo: null,
      minimumRequired: null,
      periodList: [
        {
          id: 1,
          description: "January to June",
        },
        {
          id: 2,
          description: "July to December",
        },
        {
          id: 3,
          description: "January to December",
        },
      ],
      title: null,
      presidentUser: null,
      isHeadPresident: null,
      usersList: [],
      recommendingUsersList: [],
    };
  },
  watch: {
    data: {
      handler(data) {
        console.log("Year Form", data.yearFrom);
        this.dialog = true;
        this.loadYearFrom();
        this.getUsers();

        if (data.id) {
          this.period = data.period;
          this.strat_type = data.strat_type;
          this.id = data.id;
          this.year = data.year;
          this.title = data.title;
          this.dateFrom = data.yearFrom;
          this.dateTo = data.yearTo;
        } else {
          this.period = null;
          this.strat_type =
            this.tab == 1
              ? "SDP"
              : this.tab == 2
              ? "SUC"
              : this.tab == 3
              ? "GAA"
              : "DRDP";
          this.id = null;
          this.year = null;
          this.title = data.title;
          this.dateFrom = data.yearFrom;
          this.dateTo = data.yearTo;
        }
      },

      deep: true,
    },
  },

  methods: {
    initialize() {},

    getUsers() {
      this.axiosCall("/user-details/getDeanDirAboveUsers", "GET").then(
        (res) => {
          let data = res.data;
          data.forEach((element, i) => {
            data[i].name = this.toTitleCase(element.name);
          });
          this.usersList = data;
          // console.log(res.data);
        },
      );
    },

    loadYearFrom() {
      let d = new Date();

      let yr = d.getFullYear();

      for (let i = yr; i < yr + 10; i++) {
        this.yearListFrom.push(i);
      }
    },
    onChangeDateFrom(data) {
      if (this.strat_type == "SDP") {
        this.dateTo = data + 4;
      }
    },

    closeD() {
      this.eventHub.$emit("closeStrategicPriority", false);
      this.dialog = false;
    },

    addnew() {
      if (this.$refs.AddStrategicPriority.validate()) {
        let data = {
          title: this.title,
          yearFrom: this.dateFrom,
          yearTo: this.dateTo,
          strat_type: this.strat_type,
        };
        // console.log(data);
        this.axiosCall("/strategic-planning", "POST", data).then((res) => {
          if (res.data.status == 201) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.closeD();
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        });
      } else {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.message = "Please fill-up all field please!";
      }
    },

    update() {
      if (this.$refs.AddStrategicPriority.validate()) {
        let data = {
          title: this.title,
          yearFrom: this.dateFrom,
          yearTo: this.dateTo,
          strat_type: this.strat_type,
        };

        this.axiosCall(
          "/strategic-planning/updateStrategicPlanning/" + this.id,
          "PATCH",
          data,
        ).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.closeD();
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.dialog-header {
  background-color: #f5f7f9;
}
</style>
